export { c as createFlatProxy, a as createRecursiveProxy } from '../index-044a193b.mjs';
export { g as getErrorShape, t as transformTRPCResponse } from '../transformTRPCResponse-3dca0b20.mjs';
import '../codes-24aa1ce1.mjs';
